import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../../../../Notifications/store/notificationsSlice";
import { updatePhoto } from "../../../store/controlPanelThunks";
import { setOpenModal } from "../../../store/controlPanelSlice";
import PhotoAdjuster from "../../../../../components/AvatarPhoto/PhotoAdjuster";
import { useTranslation } from "react-i18next";
import NotificationBuilder from "../../../../Notifications/utils/NotificationBuilder";
const AdjustPhoto = () => {
  const { t } = useTranslation();
  const { capturedImage } = useSelector((state) => state.profilePhoto);
  const {
    localAvatar
  } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const returnToTakePhoto = () => {
    dispatch(setOpenModal("take_photo"));
  };


  const handleSave = async (file, preview) => {
    if (!file) return;

    // Validate type
    const allowedTypes = ["image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      const notification = NotificationBuilder.error()
                          .withHeader('TYPE_INVALIDE', true)
                          .build()
      dispatch(addNotification(notification));
      return;
    }

    // Prepare upload
    const formData = new FormData();
    formData.append("file", file); // IMPORTANT: upload THE FILE

    await dispatch(
      updatePhoto({
        body: formData,
        params: [{ userId: localAvatar.id }],
      })
    );
    dispatch(setOpenModal(null));
  };


  if (!capturedImage) return null;

  return (
    <PhotoAdjuster
      image={capturedImage}
      onSave={handleSave}
      onReturn={returnToTakePhoto}
    />
  );
};

export default AdjustPhoto;
